module.exports = __webpack_public_path__ + "static/img/bg-es.79ed3b98.png";